const RETIRED_TOOL_NAMES: Readonly<Record<string, string>> = {
  listCombinedEventsForBuyer: "listBuyerEvents",
  answerSeV2Question: "answerSeQuestion",
  getBuyerSeV2Questions: "getBuyerSeQuestions",
};

export const currentToolName = (name: string): string => RETIRED_TOOL_NAMES[name] ?? name;
